Vue.component("store-special-box", {
  template: "#store-special-box",
  inject: {
    itemId: {
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentVariation() {
      return this.$store.getters[`${this.itemId}/currentItemVariation`];
    },
  },
});
